import { toDisplayString as _toDisplayString, vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b3415fbe")

_pushScopeId("data-v-b3415fbe")
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "device-list-card-content" }
const _hoisted_3 = {
  key: 0,
  class: "device-list-table"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_5 = { class: "action" }
const _hoisted_6 = { class: "services" }
const _hoisted_7 = { class: "other-services" }
const _hoisted_8 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "no-devices"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")
  const _component_router_link = _resolveComponent("router-link")
  const _component_device_connection = _resolveComponent("device-connection")
  const _component_device_other_services = _resolveComponent("device-other-services")
  const _component_card_component = _resolveComponent("card-component")

  return (_openBlock(), _createBlock(_component_card_component, {
    class: "device-list",
    title: _ctx.$t('devices-title')
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("label", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("search")) + " : ", 1),
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter = $event)),
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.filter]
          ])
        ])
      ])
    ]),
    footer: _withId(() => [
      _createVNode(_component_router_link, {
        class: "btn",
        to: "/home/device/add"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("add-device-button")), 1)
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.deviceConnectionError) + " ", 1),
        _createVNode(_component_router_view),
        (_ctx.devices && _ctx.devices.length > 0)
          ? (_openBlock(), _createBlock("table", _hoisted_3, [
              _createVNode("thead", null, [
                _createVNode("tr", null, [
                  _hoisted_4,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (c, i) => {
                    return (_openBlock(), _createBlock("th", { key: i }, _toDisplayString(_ctx.$t(`device_${c}`)), 1))
                  }), 128)),
                  _createVNode("th", null, _toDisplayString(_ctx.$t("device_action")), 1),
                  _createVNode("th", null, _toDisplayString(_ctx.$t("device_services")), 1),
                  _createVNode("th", null, _toDisplayString(_ctx.$t("device_other_services")), 1)
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.devices, (device, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: device.id
                  }, [
                    _createVNode("td", null, _toDisplayString(index + 1) + ".", 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (c, i) => {
                      return (_openBlock(), _createBlock("td", { key: i }, _toDisplayString(_ctx.translate(device[c])), 1))
                    }), 128)),
                    _createVNode("td", _hoisted_5, [
                      _createVNode(_component_router_link, {
                        class: "btn",
                        to: { path: `/home/device/${device.id}` }
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("update")), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_router_link, {
                        class: "btn danger",
                        to: "#",
                        onClick: ($event: any) => (_ctx.deleteDevice(device.id))
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("delete")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createVNode("td", _hoisted_6, [
                      _createVNode(_component_device_connection, {
                        onError: _cache[2] || (_cache[2] = (e) => (_ctx.deviceConnectionError = e)),
                        device: device
                      }, null, 8, ["device"])
                    ]),
                    _createVNode("td", _hoisted_7, [
                      _createVNode(_component_device_other_services, { device: device }, null, 8, ["device"])
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode("tfoot", null, [
                _createVNode("tr", null, [
                  _hoisted_8,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (c, i) => {
                    return (_openBlock(), _createBlock("th", { key: i }, _toDisplayString(_ctx.$t(`device_${c}`)), 1))
                  }), 128)),
                  _createVNode("th", null, _toDisplayString(_ctx.$t("device_action")), 1),
                  _createVNode("th", null, _toDisplayString(_ctx.$t("device_services")), 1),
                  _createVNode("th", null, _toDisplayString(_ctx.$t("device_other_services")), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("No devices")), 1))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})